import { render, staticRenderFns } from "./button-menu.vue?vue&type=template&id=49e9ccba"
import script from "./button-menu.vue?vue&type=script&lang=js"
export * from "./button-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports